import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { PostCall } from '../../../hooks/api/usePostCall';
import { Subheader } from '../post-call-form';
import { RadioButton } from '../../radio-button';

const connectAgainOptions = [
  { name: 'Yes', value: true },
  { name: 'No', value: false },
];

export interface ConnectAgainStepProps {
  postCall?: PostCall;
  className?: string;
}

export const ConnectAgainStep: React.FC<ConnectAgainStepProps> = ({ postCall, className }) => {
  const { control } = useFormContext();

  return (
    <div className={twMerge('flex flex-col gap-6', className)}>
      <Subheader
        question={
          <>
            Would you be open to connecting with{' '}
            <span className="font-bold">{postCall?.call.listener_role.user.display_name}</span> again?
          </>
        }
        postCall={postCall}
      />

      <div className="flex flex-col gap-2">
        {connectAgainOptions.map(({ name, value: selectionValue }) => (
          <Controller
            key={name}
            control={control}
            name="connectAgain"
            render={({ field: { value, onChange } }) => (
              <label
                htmlFor={`connect-again-${name}`}
                onClick={() => onChange(selectionValue)}
                className={twMerge(
                  'flex cursor-pointer items-center gap-3 rounded-[12px] border px-4 py-3 transition-colors',
                  value === selectionValue
                    ? 'border-selected-border bg-selected-bg'
                    : 'border-input-border-gray bg-gray-50 hover:bg-gray-100',
                )}
              >
                <RadioButton
                  checked={value === selectionValue}
                  onChange={() => onChange(selectionValue)}
                  data-testid={`connect-again-option-${name}`}
                />
                <span className="text-label-gray font-['Albert_Sans'] text-base font-medium leading-5">{name}</span>
              </label>
            )}
          />
        ))}
      </div>
    </div>
  );
};
